import React, {Component} from 'react';
import PropTypes from 'prop-types';
import BaseComponent from "../../../../base/BaseComponent";
import moment from "moment";
import {Empty} from 'antd';


export default class RelatedResources extends BaseComponent {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            thisTabKey: '1',
            page: 1,
            size: 10,
            dataSource:[

            ],
            virtualFileId:this.props.id

        }
    }

    componentWillMount() {
    }

    componentDidMount() {
        this.getFile()
    }

    render() {
        let {dataSource} = this.state;
        return (
           <div style={{padding:'24px'}}>
               { dataSource&&dataSource.length?<div>{
                   dataSource.map((item,index)=>{
                       return(
                           <div key={index} style={{
                               width: '304px',
                               height:' 64px',
                               background: "rgba(0,80,179,0.03)",
                               border: "1px solid rgba(0,80,179,0.0784)",
                               borderRadius: "5px",
                               marginBottom:'16px',
                               padding:'5px 12px',
                               fontSize: "14px",
                               borderLeft:item.showBorderLeft?'4px solid #0092fe':null
                           }}
                                onClick={()=>{
                                    this.itemClick(item,index)

                                }}
                           >
                               <div style={{color: "rgba(0,0,0,0.85)"}}  className={'twoText'} >{item.operatorName}</div>
                               <div style={{color: "rgba(0,0,0,0.45)",marginTop:'6px'}}>{moment(item.createTime).format('YYYY-MM-DD HH:mm:ss' )}</div>
                           </div>
                       )
                   })
               }</div>:<Empty style={{marginTop:150}}/>}
           </div>
        )
    }
    //版本追踪
    getFile (){

        this.request({
            url: '/cm-sites-sys/process/getProcessHistory',
            method: 'post',
            body: {
                bizKey: this.state.virtualFileId
            },
            callBack: (data) => {
             let  dataSource = [];
              if(data&&data.length){
                  dataSource =  data;
                  dataSource[0].showBorderLeft = true
              }
              this.setState({dataSource})
            }
        });
    }

    itemClick(Item,index){
        let {dataSource} =this.state;
        dataSource&&dataSource.length&&dataSource.forEach((item,index)=>{
            if(item.id ===Item.id ){
                item.showBorderLeft =true
            }else{
                item.showBorderLeft =false
            }
        });
        this.props.callBack&&this.props.callBack(Item.processData.data)
        this.setState({})
    }


}